import { render, staticRenderFns } from "./EditPoll.vue?vue&type=template&id=48df392d&scoped=true&"
import script from "./EditPoll.vue?vue&type=script&lang=ts&"
export * from "./EditPoll.vue?vue&type=script&lang=ts&"
import style0 from "./EditPoll.vue?vue&type=style&index=0&id=48df392d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df392d",
  null
  
)

export default component.exports